import AssessmentOutlined from '@mui/icons-material/AssessmentOutlined';
import FolderOutlined from '@mui/icons-material/FolderOutlined';
import KeyboardArrowRightOutlined from '@mui/icons-material/KeyboardArrowRightOutlined';
import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';
import Stack from '@mui/material/Stack';
import type { SvgIconProps } from '@mui/material/SvgIcon';
import Typography from '@mui/material/Typography';
import { useNavigate } from '@tanstack/react-router';
import type { ComponentType, ReactNode } from 'react';

// Figma 12054:64347: two 78px teasers into pages that already exist; no counts are claimed.
function Teaser({
  Icon,
  title,
  body,
  onClick,
}: {
  Icon: ComponentType<SvgIconProps>;
  title: string;
  body: string;
  onClick: () => void;
}): ReactNode {
  return (
    <ButtonBase
      onClick={onClick}
      sx={{
        height: 78,
        px: '20px',
        gap: '14px',
        justifyContent: 'flex-start',
        textAlign: 'left',
        bgcolor: 'background.paper',
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: '14px',
        '&:hover': { bgcolor: 'background.page' },
      }}
    >
      <Box
        sx={{
          width: 40,
          height: 40,
          borderRadius: '10px',
          display: 'grid',
          placeItems: 'center',
          bgcolor: 'primary.bg',
          color: 'primary.main',
          flexShrink: 0,
        }}
      >
        <Icon sx={{ fontSize: 22 }} />
      </Box>
      <Stack sx={{ flex: 1, minWidth: 0, gap: '3px' }}>
        <Typography sx={{ fontSize: 14, fontWeight: 600, color: 'background.icon' }}>
          {title}
        </Typography>
        <Typography sx={{ fontSize: 12, color: 'text.secondary' }} noWrap>
          {body}
        </Typography>
      </Stack>
      <KeyboardArrowRightOutlined sx={{ fontSize: 16, color: 'text.secondary' }} />
    </ButtonBase>
  );
}

export function ReportsAndOutcomes(): ReactNode {
  const navigate = useNavigate();
  return (
    <Box
      component="section"
      aria-label="Reports and outcomes"
      data-testid="reports-outcomes"
      sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' }, gap: '16px' }}
    >
      <Teaser
        Icon={AssessmentOutlined}
        title="Browse reports"
        body="Every report Alison has generated for your account"
        onClick={() => void navigate({ to: '/reports/performance' })}
      />
      <Teaser
        Icon={FolderOutlined}
        title="Outcomes"
        body="Briefs, storyboards and flight checks your workflows saved"
        onClick={() => void navigate({ to: '/outcomes' })}
      />
    </Box>
  );
}
